import validate from "/home/viva/source/techedu/frontvue/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@vue+compiler-sfc@3.5.44_cac@6.7.14_db0@0.3.4_e_ed6b8f5ecee971df2d373d33aadc32cf/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/viva/source/techedu/frontvue/src/middleware/auth.global.js";
import manifest_45route_45rule from "/home/viva/source/techedu/frontvue/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@vue+compiler-sfc@3.5.44_cac@6.7.14_db0@0.3.4_e_ed6b8f5ecee971df2d373d33aadc32cf/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}